import GoalError from './GoalError';
class InvalidGoalId extends GoalError {
    constructor(goalId, options) {
        super(`The goal with id ${goalId} is invalid`, options);
    }
}
export default InvalidGoalId;
